import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import PublicForm from './PublicForm';

const Waitlist = () => {
  useEffect(() => {
    trackPageView('Waitlist');
  }, []);

  return (
    <div className="min-h-screen bg-cream-50" data-testid="waitlist-page">
      <SiteHeader active="waitlist" />

      {/* Hero */}
      <section className="relative overflow-hidden bg-[#1a0d10] text-white py-20 md:py-28 px-4 md:px-6">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(124,29,51,0.22),transparent_55%),radial-gradient(ellipse_at_bottom_left,rgba(139,30,63,0.16),transparent_60%)]" />
        <div className="absolute inset-0 grain" />
        <div className="max-w-5xl mx-auto text-center relative z-10">
          <p className="eyebrow text-white/50 mb-5">Registration Closed</p>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl font-semibold leading-[0.95] tracking-tighter mb-6">
            <span className="block">Join the</span>
            <span className="block bg-gradient-to-br from-[#a8324a] via-[#c0455c] to-[#d9a15b] bg-clip-text text-transparent">
              Waitlist
            </span>
          </h2>
          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed">
            All 140 spots for the 2026 retreat are filled. Fill out the form below and we&apos;ll reach out
            only if a spot opens up.
          </p>
        </div>
      </section>

      {/* Reservation notice */}
      <section className="py-12 md:py-14 px-4 md:px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="bg-wine-50 border-2 border-wine/30 rounded-xl p-6 md:p-8 text-center space-y-4">
            <p className="text-xl md:text-2xl font-bold text-wine-700">
              Registration Is Full — Waitlist Only
            </p>
            <p className="text-base md:text-lg text-gray-800 leading-relaxed">
              Tickets are reserved strictly in the order that both the registration form and payment are received.
              Submitting the form alone does not reserve a spot. Your registration is not guaranteed until you receive
              a confirmation email. A deposit will hold your place in line pending confirmation.
            </p>
            <div className="bg-amber-50 border-2 border-amber-400 rounded-lg p-5 md:p-6 text-left">
              <p className="text-base md:text-lg font-bold text-amber-900 mb-2">
                Joining the waitlist? Do NOT pay yet.
              </p>
              <p className="text-sm md:text-base text-amber-900 leading-relaxed">
                Fill out the registration form below to add yourself to the waitlist.{' '}
                <span className="font-bold">Only submit payment AFTER you receive a registration confirmation email</span>{' '}
                letting you know a spot has opened up for you. If you pay before that, we&apos;ll refund you — but it
                delays everyone. When it&apos;s time, head to the{' '}
                <Link to="/payment" className="underline font-semibold text-wine-700 hover:text-wine-800">
                  Payment page
                </Link>.
              </p>
            </div>
            <p className="text-base md:text-lg text-gray-800 leading-relaxed">
              <span className="font-bold text-gray-900">Please note:</span> Do not submit payment for anyone who has not
              completed the registration form. If you are paying for multiple attendees, each person must submit their
              own registration form before payment is made.
            </p>
          </div>
        </div>
      </section>

      {/* Native waitlist form */}
      <section className="py-12 md:py-20 px-4 md:px-6 bg-gray-50 border-t border-gray-200">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-6 md:mb-8">
            <h3 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 px-4">
              Waitlist Registration Form
            </h3>
            <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Fill out your details below. You&apos;ll be contacted only if a spot opens up.
            </p>
          </div>

          <PublicForm />
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default Waitlist;
